<section class="features-area">
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-lg-3 col-sm-6 col-md-6 p-0">
                <div class="single-features-box">
                    <div class="inner-content">
                        <h3>Курсы по подготовке к ОРТ</h3>
                        <p>Онлайн курсы от лучших преподователей наших учреждений с огромным опытом по подготовке к ОРТ.</p>
                        <a routerLink="/courses" class="default-btn"><i class='bx bx-log-in-circle icon-arrow before'></i><span class="label">Открыть</span><i class="bx bx-log-in-circle icon-arrow after"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-6 p-0">
                <div class="single-features-box">
                    <div class="inner-content">
                        <h3>Пробные тесты по основным предметам</h3>
                        <p>Максимально приближённые тесты к ОРТ.</p>
                        <a routerLink="/coming-soon" class="default-btn"><i class='bx bx-log-in-circle icon-arrow before'></i><span class="label">Открыть</span><i class="bx bx-log-in-circle icon-arrow after"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-6 p-0">
                <div class="single-features-box">
                    <div class="inner-content">
                        <h3>Пробные тесты по дополнительным предметам</h3>
                        <p>Химия, Биология, Английский язык, История, Математика.</p>
                        <a routerLink="/coming-soon" class="default-btn"><i class='bx bx-log-in-circle icon-arrow before'></i><span class="label">Открыть</span><i class="bx bx-log-in-circle icon-arrow after"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-6 p-0">
                <div class="single-features-box">
                    <div class="inner-content">
                        <h3>Видеоуроки, экзамены</h3>
                        <p>Все уроки доступны в удобном формате видео + экзамены.</p>
                        <a routerLink="/courses" class="default-btn"><i class='bx bx-log-in-circle icon-arrow before'></i><span class="label">Открыть</span><i class="bx bx-log-in-circle icon-arrow after"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="slideshow-box">
        <ul class='slideshow-slides owl-carousel owl-theme'>
            <li><span class="bg0"></span></li>
<!--            <li><span class="bg3"></span></li>-->
<!--            <li><span class="bg2"></span></li>-->
<!--            <li><span class="bg1"></span></li>-->
<!--            <li><span class="bg4"></span></li>-->
            <!-- <li><span class="bg5"></span></li> -->
        </ul>
    </div>
</section>
